<script setup lang="ts">
import { computed } from "vue";
import { responsiveClass } from "../../utilities/helpers";
import type { IHiddenProps } from "./VHidden.types";

const props = withDefaults(defineProps<IHiddenProps>(), {
  tag: "div",
  hide: false,
});

const rootClass = computed(() => {
  return [
    {
      ["pl-hidden_inline"]: props.inline,
      ["pl-hidden_visibility"]: props.visibility,
    },
    ...responsiveClass("pl-hidden_hide", props.hide),
  ];
});
</script>

<template>
  <component :is="props.tag" class="pl-hidden" :class="rootClass">
    <slot />
  </component>
</template>

<style lang="postcss">
.pl-hidden {
  --pl-hidden-display: block;

  display: var(--pl-hidden-display) !important;
}

.pl-hidden_inline {
  --pl-hidden-display: inline;
}

.pl-hidden_hide {
  display: none !important;

  &.pl-hidden_visibility {
    display: var(--pl-hidden-display) !important;
    visibility: hidden;
  }
}

@media (--pl-viewport-from-s) {
  .pl-hidden_hide-false-s {
    display: var(--pl-hidden-display) !important;

    &.pl-hidden_visibility {
      visibility: visible;
    }
  }

  .pl-hidden_hide-true-s {
    display: none !important;

    &.pl-hidden_visibility {
      display: var(--pl-hidden-display) !important;
      visibility: hidden;
    }
  }
}

@media (--pl-viewport-from-m) {
  .pl-hidden_hide-false-m {
    display: var(--pl-hidden-display) !important;

    &.pl-hidden_visibility {
      visibility: visible;
    }
  }

  .pl-hidden_hide-true-m {
    display: none !important;

    &.pl-hidden_visibility {
      display: var(--pl-hidden-display) !important;
      visibility: hidden;
    }
  }
}

@media (--pl-viewport-from-ml) {
  .pl-hidden_hide-false-ml {
    display: var(--pl-hidden-display) !important;

    &.pl-hidden_visibility {
      visibility: visible;
    }
  }

  .pl-hidden_hide-true-ml {
    display: none !important;

    &.pl-hidden_visibility {
      display: var(--pl-hidden-display) !important;
      visibility: hidden;
    }
  }
}

@media (--pl-viewport-from-l) {
  .pl-hidden_hide-false-l {
    display: var(--pl-hidden-display) !important;

    &.pl-hidden_visibility {
      visibility: visible;
    }
  }

  .pl-hidden_hide-true-l {
    display: none !important;

    &.pl-hidden_visibility {
      display: var(--pl-hidden-display) !important;
      visibility: hidden;
    }
  }
}

@media (--pl-viewport-from-xl) {
  .pl-hidden_hide-false-xl {
    display: var(--pl-hidden-display) !important;

    &.pl-hidden_visibility {
      visibility: visible;
    }
  }

  .pl-hidden_hide-true-xl {
    display: none !important;

    &.pl-hidden_visibility {
      display: var(--pl-hidden-display) !important;
      visibility: hidden;
    }
  }
}
</style>
